import React, { useRef, useState } from 'react'
import { Input } from 'antd'
import { useTranslation } from 'react-i18next'
import * as CSS from './styles'

type Props = {
  initialValues: string
  onChange(values: string): void
}

export default function RequestNumberFilter({
  initialValues = '',
  onChange
}: Props) {
  const refTimeout = useRef<NodeJS.Timeout>(null)
  const { t } = useTranslation()

  const [value, setValue] = useState<string>(initialValues)

  return (
    <CSS.Content>
      <Input
        allowClear
        data-test-id="request-number-filter"
        defaultValue={initialValues}
        onChange={({ target: { value = '' } }) => {
          setValue(value)
          clearTimeout(refTimeout.current)
          refTimeout.current = setTimeout(() => {
            const sanitizedValue = value
              .replace(/^,+|[^0-9,]+|\0|,+$/gm, '')
              .replace(/,{2,}/gm, ',')
            setValue(sanitizedValue)
            onChange(sanitizedValue)
          }, 1000)
        }}
        placeholder={t('common.request-number-filter')}
        value={value}
      />
    </CSS.Content>
  )
}
